import * as React from 'react';
import { Component } from '../../lib/component';
import { FormattedMessage } from 'react-intl';
import { prepareStatistics } from '../../lib/helpers';
import {ChannelStatisticsSchema} from '../../types/schema';
import {style} from 'typestyle';
import {px} from 'csx';
import {colorSubtle} from '../../theme/color';

export interface ChannelStatisticsProps {
  statistics: ChannelStatisticsSchema;
}

export class ChannelStatistics extends Component<ChannelStatisticsProps> {
  render() {
    const statistics = prepareStatistics(this.props.statistics);

    return (
      <div className={ChannelStatistics.styles.container}>
        <FormattedMessage tagName="h4" id="channel.statistics.title" values={statistics} />
        <dl>
          <dt>
            <FormattedMessage id="channel.statistics.video_count.label" />
          </dt>
          <dd>
            <FormattedMessage id="channel.statistics.video_count.value" values={statistics} />
          </dd>
          <dt>
            <FormattedMessage id="channel.statistics.comment_count.label" />
          </dt>
          <dd>
            <FormattedMessage id="channel.statistics.comment_count.value" values={statistics} />
          </dd>
          <dt>
            <FormattedMessage id="channel.statistics.view_count.label" />
          </dt>
          <dd>
            <FormattedMessage id="channel.statistics.view_count.value" values={statistics} />
          </dd>
        </dl>
      </div>
    )
  }

  static styles = {
    container: style({
      $nest: {
        '& dt': {
          fontSize: px(12),
          color: colorSubtle.toString(),
        },
        '& dd': {
          margin: '0 0 10px 0'
        }
      }
    })
  }
}